import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const BoxWithDropShadow = styled(Box)(() => ({
  filter: 'drop-shadow(2px 3px 10px rgba(115, 132, 192, 0.5))',
}));

export default BoxWithDropShadow;
